import localComparePolyfill from "locale-compare-polyfill";

/**
 * @method
 */
const helperUtilities = function (app) {
    const init = function () {
        // only init this stuff once please!
        if (!app.utilitesInit) {
            initDetectMobileBrowsersScript();
            // detectIos();
            detectAndroid();
            // detectIE();
            // detectEdge();
            saveDblClicks();
            detectTouch();
            // scrollToTop();
            detectCachedPage();
        }
        app.utilitesInit = true;
    };

    const initDetectMobileBrowsersScript = function () {
        /**
         * jQuery.browser.mobile (http://detectmobilebrowser.com/)
         *
         * jQuery.browser.mobile will be true if the browser is a mobile device
         *
         **/
        (function (a) {
            (jQuery.browser = jQuery.browser || {}).mobile =
                /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
                    a,
                ) ||
                /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                    a.substr(0, 4),
                );
        })(navigator.userAgent || navigator.vendor || window.opera);
    };

    // const detectIos = function() {
    //     const userAgentTest = navigator.userAgent.toLowerCase();
    //     if (typeof(document.querySelectorAll) != 'undefined' && !document.querySelector('html').classList.contains('ios') && /iphone|ipad|ipod/i.test(userAgentTest)) {
    //         window.PLATFORM_IOS = true;

    //         if (/iphone|ipod|ipad/i.test(userAgentTest)) {
    //             document.querySelector('html').classList.add('ios');
    //             if (/iphone|ipod/i.test(userAgentTest)) {
    //                 document.querySelector('html').classList.add('iphone');
    //             } else if (/ipad/i.test(userAgentTest)) {
    //                 document.querySelector('html').classList.add('ipad');
    //             }
    //             if (document.querySelector('body')) { // testing just because of a bug in the SC5 pattern library
    //                 document.querySelector('body').setAttribute('ontouchstart',''); // this is an old iOS hack to get :hover and :active states working. Not needed for Android.
    //             }
    //             let safariVersMaj = /version\/([0-9]*)./.exec(userAgentTest);
    //             if (safariVersMaj) {
    //                 safariVersMaj = parseInt(safariVersMaj[1]);
    //                 document.querySelector('html').classList.add('ios' + safariVersMaj);
    //             }
    //         }
    //     }
    // };

    const detectAndroid = function () {
        const userAgentTest = navigator.userAgent.toLowerCase();
        if (
            typeof document.querySelectorAll != "undefined" &&
            !document.querySelector("html").classList.contains("android") &&
            /android/i.test(userAgentTest)
        ) {
            window.PLATFORM_ANDROID = true;

            if (
                /android/i.test(userAgentTest) &&
                /mobile/i.test(userAgentTest)
            ) {
                document
                    .querySelector("html")
                    .classList.add("android", "android-mobile");
            } else if (/android/i.test(userAgentTest)) {
                document
                    .querySelector("html")
                    .classList.add("android", "android-tablet");
            }
            // detect samsung browser variation of Chromium (it's a big enough segment that it's worth flagging)
            // if (/samsungbrowser/i.test(userAgentTest)) {
            //     document.querySelector('html').classList.add('samsung-browser');
            // }
            // // detect if this version of Android Chrome supports 100%VH as the minimum vertical space (on page load, with url bar/tabs) or maximum vertical space (after scrolling down).
            // // The behaviour changed in 56, and it has a profound effect if we're trying to guess the vertical size of the screen in CSS! This effects Samsung Browser too, as it normally lags about 8 versions behind in chromium.
            // let chromeVersMaj = /chrome\/([0-9]*)./.exec(userAgentTest);
            // if (chromeVersMaj) {
            //     chromeVersMaj = parseInt(chromeVersMaj[1]);
            //     if (chromeVersMaj < 56) {
            //         document.querySelector('html').classList.add('android-vh-old');
            //     }
            // // else mark that this is a non chrome browsers (probably the old webkit one or possibly Opera mini)
            // } else {
            //     window.PLATFORM_ANDROID_PRECHROME = true;
            //     document.querySelector('html').classList.add('android-nochrome');
            // }
        }
    };

    // const detectIE = function() {
    //     const userAgentTest = navigator.userAgent.toLowerCase();
    //     if (typeof(document.querySelectorAll) != 'undefined' && !document.querySelector('html').classList.contains('ie') && /trident/i.test(userAgentTest)) {
    //         if (/trident/i.test(userAgentTest)) {
    //             window.BROWSER_IE = true;
    //             document.querySelector('html').classList.add('ie');
    //             let ieVersMaj = /rv:([0-9]*)./.exec(userAgentTest);
    //             if (ieVersMaj) {
    //                 ieVersMaj = parseInt(ieVersMaj[1]);
    //                 document.querySelector('html').classList.add('ie' + ieVersMaj);
    //             }
    //         }
    //     }
    // };

    // const detectEdge = function() {
    //     const userAgentTest = navigator.userAgent.toLowerCase();
    //     if (typeof(document.querySelectorAll) != 'undefined' && !document.querySelector('html').classList.contains('edge') && / Edge/i.test(userAgentTest)) {
    //         if (/edge/i.test(userAgentTest)) {
    //             window.BROWSER_EDGE = true;
    //             document.querySelector('html').classList.add('edge');
    //             let EdgeVersMaj = /edge\/([0-9]*)./.exec(userAgentTest);
    //             if (EdgeVersMaj) {
    //                 EdgeVersMaj = parseInt(EdgeVersMaj[1]);
    //                 document.querySelector('html').classList.add('edge' + EdgeVersMaj);
    //             }
    //         }
    //     }
    // };

    // detect touch screens on first countact with a big squidgy finger
    const detectTouch = function (obj) {
        window.addEventListener(
            "touchstart",
            function onFirstTouch() {
                document.querySelector("html").classList.add("touch");
                window.TOUCH_ENABLED = true;
                window.removeEventListener("touchstart", onFirstTouch, false);
            },
            supportsPassive ? { passive: true } : false,
        );
    };

    // double clicks - almost never actually the intended outcome. kill them with fire.
    const saveDblClicks = function () {
        $(document).on("dblclick", "button,a", function (ev) {
            const $this = $(this);

            // translate to a regular click
            ev.preventDefault();
            $this.trigger("click");
            // and double clicking a link or label starts to select it's text. This is also unwanted, so unselect it.
            unselectAllText();
        });
    };

    // remove unwanted selected text (often a byproduct of accidently double clicking on a button, link, etc)
    const unselectAllText = function () {
        if (document.selection) {
            document.selection.empty();
        } else if (window.getSelection) {
            window.getSelection().removeAllRanges();
        }
    };

    // Test via a getter in the options object to see if the passive property is accessed
    var supportsPassive = false;
    try {
        var opts = Object.defineProperty({}, "passive", {
            get: function () {
                supportsPassive = true;
            },
        });
        window.addEventListener("test", null, opts);
    } catch (e) {}

    // our own clone
    const clone = function (obj) {
        var copy;

        // Handle the 3 simple types, and null or undefined
        if (null === obj || "object" != typeof obj) return obj;

        // Handle Date
        if (obj instanceof Date) {
            copy = new Date();
            copy.setTime(obj.getTime());
            return copy;
        }

        // Handle Array
        if (obj instanceof Array) {
            copy = [];
            for (var i = 0, len = obj.length; i < len; i++) {
                copy[i] = clone(obj[i]);
            }
            return copy;
        }

        // Handle Object
        if (obj instanceof Object) {
            copy = {};
            for (var attr in obj) {
                if (obj.hasOwnProperty(attr)) copy[attr] = clone(obj[attr]);
            }
            return copy;
        }

        throw new Error("Unable to copy obj! Its type isn't supported.");
    };

    // array intersection method: http://stackoverflow.com/posts/1885766/revisions
    const intersect = function (a, b) {
        var d = {};
        var results = [];
        for (var i = 0; i < b.length; i++) {
            d[b[i]] = true;
        }
        for (var j = 0; j < a.length; j++) {
            if (d[a[j]]) results.push(a[j]);
        }
        return results;
    };

    // scroll the page to the top of an element
    // const scrollToEl = function(selector,duration) {
    //     if (duration < 0 )
    //         duration = 600;
    //     $("html, body").animate({ scrollTop: $(selector).offset().top }, duration);
    // };

    // pre-packaged scroll to top, the most common usecase
    // const scrollToTop = function() {
    //     $('[data-js-to-top]').click(function(ev) {
    //         ev.preventDefault();
    //         scrollToEl('[data-js-top]');
    //     });
    // };

    const getAppName = function () {
        return $("[data-cookie-app]").data("cookie-app");
    };

    const detectCachedPage = function () {
        //window.addEventListener( 'pageshow', function( ev ){
        //    if (window.performance && window.performance.navigation.type=='2') {
        //        alert('CACHED')
        //       console.log('CACHED!!')
        //    }
        //});
    };

    // URL LOCATION/SEARCH MANIPULATION

    const searchToHash = function () {
        let h = {};
        if (
            window.location.search == undefined ||
            window.location.search.length < 1
        ) {
            return h;
        }
        let q = window.location.search.slice(1).split("&");
        for (var i = 0; i < q.length; i++) {
            let key_val = q[i].split("=");
            // replace '+' (alt space) char explicitly since decode does not
            let hkey = decodeURIComponent(key_val[0]).replace(/\+/g, " ");
            let hval = decodeURIComponent(key_val[1]).replace(/\+/g, " ");
            if (h[hkey] == undefined) {
                h[hkey] = new Array();
            }
            h[hkey].push(hval);
        }
        return h;
    };

    const hashToSearch = function (h) {
        let search = "?";
        for (var k in h) {
            for (var i = 0; i < h[k].length; i++) {
                search += search == "?" ? "" : "&";
                search +=
                    encodeURIComponent(k) + "=" + encodeURIComponent(h[k][i]);
            }
        }
        if (search && search.trim() === "?") {
            search = "";
        }
        return search;
    };

    const getQueryVariable = function (variable) {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (decodeURIComponent(pair[0]) == variable) {
                return decodeURIComponent(pair[1]);
            }
        }
        //console.log('Query variable %s not found', variable);
    };

    const addQueryVariable = function (name, value) {
        const newSearchHash = hashToSearch();
        newSearchHash[decodeURIComponent(name)] = decodeURIComponent(value);
        return hashToSearch(newSearchHash);
    };

    const removeQueryVariable = function (name) {
        const newSearchHash = searchToHash();
        if (newSearchHash[name]) {
            delete newSearchHash[name];
        }
        return hashToSearch(newSearchHash);
    };

    // use an event to detect if a click event is a keyboard enter (ie, a keyboard navigation event), or a mouse click event.
    // This helps use change the UI like using keyboard highlights where appropriate.
    // returns true for keyboard events, false for mouseclick events, and optionally runs a callback if it's a keyboard event
    const keyboardClick = function (ev, callback) {
        if (ev && ev.clientX === 0 && ev.clientY === 0) {
            // act on results
            if (typeof callback === "function") {
                callback();
            }
            return true;
        } else {
            return false;
        }
    };

    // turn a string into a hash (useful for creating DOM element IDs from a text phrase, eg, "Vasagatan 1, Göteborg" to "-9616235")
    const hashCode = function (s) {
        return s.split("").reduce(function (a, b) {
            a = (a << 5) - a + b.charCodeAt(0);
            return a & a;
        }, 0);
    };

    // purpose clear
    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    return {
        init: init(),
        // detectIos,
        // detectIE,
        // detectEdge,
        detectAndroid,
        detectTouch,
        unselectAllText,
        clone,
        intersect,
        // scrollToEl,
        supportsPassive,
        getAppName,
        getQueryVariable,
        removeQueryVariable,
        keyboardClick,
        hashCode,
        capitalizeFirstLetter,
    };
};

export default helperUtilities;
